module.exports = __webpack_public_path__ + "media/images/vp/icon.menu.help2.red-ff2af09588fb67cbdcaa207b47debcbe.svg";